import { LOADING_STATUS } from '../support/constants';
import { determineLoadingStatus, reducerWrapper } from '../support/utils';

import { APP_DEFAULT_ROLES, DEFAULT_ROLES, USER_PERMISSIONS } from '../actions/AccessControlActions';

export const INIT_STATE = {
  loadingStatus: LOADING_STATUS.INIT,
  userPermissionsLoadingStatus: LOADING_STATUS.INIT,
  defaultRolesLoadingStatus: LOADING_STATUS.INIT,
  error: null,
  data: null,
  defaultRoles: null,
  defaultRoleFilters: null,
  appDefaultRoles: null,
};

const loadingStates = ['userPermissionsLoadingStatus', 'defaultRolesLoadingStatus'];

export function createInitialState() {
  return {
    ...INIT_STATE,
  };
}

function Handler(state, action) {
  const { data } = action;

  switch (action.type) {
    case USER_PERMISSIONS.response: {
      const userPermissionsState = Object.assign({}, state, {
        userPermissionsLoadingStatus: LOADING_STATUS.LOADED,
        data,
      });
      userPermissionsState.loadingStatus = determineLoadingStatus(userPermissionsState, loadingStates);
      return userPermissionsState;
    }
    case DEFAULT_ROLES.response: {
      const { rolePermissions, roleFilters } = data;

      const defaultRolesState = Object.assign({}, state, {
        defaultRolesLoadingStatus: LOADING_STATUS.LOADED,
        defaultRoles: rolePermissions,
        defaultRoleFilters: roleFilters,
      });

      defaultRolesState.loadingStatus = determineLoadingStatus(defaultRolesState, loadingStates);
      return defaultRolesState;
    }
    case APP_DEFAULT_ROLES.response: {
      return { ...state, appDefaultRoles: data };
    }
    default: {
      return state;
    }
  }
}

export default reducerWrapper(INIT_STATE, Handler, {
  request: [USER_PERMISSIONS],
  error: [USER_PERMISSIONS],
  resetOn: ['APP_CHANGE'],
});
